import React from "react";
import CorrelationRule from "./CorrelationRule";
import commonStyles from "./commonStyles.css";
class CorrelationRules extends React.Component {
  constructor() {
    super(...arguments);
    this.renderEventRule = (correlationRule, idx = 0) => {
      const { rules, eventDefinitions, onChange, onRemove } = this.props;
      return /* @__PURE__ */ React.createElement(React.Fragment, { key: correlationRule.id }, /* @__PURE__ */ React.createElement(
        CorrelationRule,
        {
          number: idx + 1,
          correlationRule,
          eventDefinitions,
          onChange,
          onRemove
        }
      ), idx + 1 < rules.length && /* @__PURE__ */ React.createElement("p", { className: commonStyles.followedBy }, "Followed by"));
    };
  }
  render() {
    const { rules } = this.props;
    return rules.map(this.renderEventRule);
  }
}
export default CorrelationRules;
